const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID
const scope =
  'instagram_basic,instagram_manage_comments,instagram_manage_insights,instagram_content_publish,pages_show_list'

//before use these functions you should call initFacebookSdk from ./facebook.js

export const connectInstagramPage = () =>
  new Promise((resolve, reject) => {
    window.FB.login(
      (response) => {
        const { authResponse } = response
        authResponse ? resolve(response) : reject(response)
      },
      { scope }
    )
  })
